import { PhotoExportClassType } from '@cims-online/shared'
import { usePhotoFilenamesQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { PhotoFilenameContext } from './types'
import { useProjectContext } from 'context/ProjectContext'

const { Provider, useContextFn } = createStrictContext<PhotoFilenameContext>(
  'PhotoFilenameContext'
)

export const usePhotoFilenamesContext = useContextFn

const PhotoFilenamesProvider: React.FC = ({ children }) => {
  const { projectId } = useProjectContext()
  const { data, loading, refetch } = usePhotoFilenamesQuery({
    ...DefaultQueryHookOptions,
    variables: { projectId },
  })
  return (
    <Provider
      value={{
        photoFilenames: PhotoExportClassType.map((classType) => ({
          ...classType,
          defaultTemplateItems: classType.defaultTemplateItems,
          templateItems:
            data?.photoFilenames?.records?.find(
              ({ classTypeId }) => classTypeId === classType.id
            )?.templateItems ?? null,
        })),
        loading,
        refetch,
      }}
    >
      {children}
    </Provider>
  )
}

export default PhotoFilenamesProvider
